// extracted by mini-css-extract-plugin
export default {"carousel":"Carousel_carousel__qA8x7"};